import React, { useState, useEffect, useCallback } from 'react'
import {
  Alert,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
  Table,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from 'reactstrap'
import DatePickerMulti from 'react-multi-date-picker'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { v4 as uuidv4 } from 'uuid'
import Checkbox from 'rc-checkbox'
import { BiCheck, BiHash, BiRecycle, BiX } from 'react-icons/bi'
import { BsChevronDown, BsDownload, BsGear, BsShare } from 'react-icons/bs'
import moment from 'moment'
import * as actionCreators from '../../../../src/modules/actions/index'
import EmptyTable from '../../../components/EmptyTable/EmptyTable'
import parse from 'react-html-parser'
import axios from '../../../axios'
import * as url from '../../../utils/url'
import MultirangeDatePickerDesigned from './MultirangeDatePickerDesigned'
import withLoading from '../../../hoc/Loading/Loading'
import { CSVLink } from 'react-csv'
import _debounce from 'lodash/debounce'
import {
  FaBarsProgress,
  FaClock,
  FaRegThumbsUp,
  FaThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
  FaWpforms,
  FaStar,
  FaCheck,
} from 'react-icons/fa6'
import {
  ATTEMPT_NO_FILTER,
  CUSTOM_QUESTION_INPUT_TYPES,
  formatDuration,
  getAttemptNumberFilterOptions,
  getInputTypeLabel,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  minPlanLimitCheck,
  sentimentPercent,
  SENTIMENTS_TYPO_MAP,
} from '../data'
import {
  contvertHTMLToPlain,
  profilePicValidityCheck,
  Spinner,
} from '../../../utils/constants'
import { isMobile } from '../../../utils/deviceInfo'
import { roundPercentagesInText } from '../../../utils/stringUtils'
import Select from 'react-select'
import { toastContainer, dismissToast } from '../../../utils/toast'
import { marked } from 'marked'
import { MdBusAlert, MdUpgrade } from 'react-icons/md'
import {
  BsEmojiFrown,
  BsEmojiSmile,
  BsEmojiNeutral,
  BsEmojiDizzy,
} from 'react-icons/bs'
import SummaryPieChart from './SummaryPieChart'
import SpinnerLoader from '../../../components/UI/SpinnerLoader/SpinnerLoader'
import TrivvyDropoffsModal from './TrivvyDropoffsModal'
import GreyOutUpgradePlanuBlockUi from '../../../components/Shared/GreyOutUpgradePlanuBlockUi'
import TriviaResultsResponses from './TriviaResultsResponses'
import Plot from '../../../utils/customPlotly'
import LinearNumericBarGraph from './Results/LinearNumericBarGraph'
import TextSentimentComponent from './Results/TextSentimentComponent'
import TextSentimentComponentOverall from './Results/TextSentimentComponentOverall'
import OptionsPiechart from './Results/OptionsPiechart'
import InclineProgressBar from '../../../components/InclineProgressBar/InclineProgressBar'
import NormalProgressBar from '../../../components/InclineProgressBar/NormalProgressbar'
import StarRatings from 'react-star-ratings'
import MessagingTriviaResultsSummary from './Results/MessagingTriviaResultsSummary'
import { FaRegFaceMehBlank } from 'react-icons/fa6'
import OoPopover from '../../../components/UI/Popover/OoPopover'
import placeHolderInsights from '../../../assets/trivvy/placeholder_insights.png'
import { IoMenu } from 'react-icons/io5'
import ShareActionsModal from './ShareTrivia/ShareActionsModal'
import TrivvyEnterpriseConfigsModal from './CreateTrivia/TrivvyEnterpriseConfigsModal'
import { BsFileBarGraph } from 'react-icons/bs'
import { IoCalendarOutline } from 'react-icons/io5'
import { GiNotebook } from 'react-icons/gi'
import { connect } from 'react-redux'

function TriviaResultsInsights({
  questions,
  surveyId,
  allowAttempts,
  currentTrivvy,
  setCurrentTrivia,
  user,
  filterResultsValues,
  isFilterLoading
}) {
  console.log(questions, "<<currentTrivvy from reslts insignts");
  const [dateRange, setDateRange] = useState([new Date()])
  const [doubledDivCount, setDoubledDivCount] = useState(0)
  const [attemptNumber, setAttemptNumber] = useState(1)
  const [summaryApiLoading, setSummaryApiLoading] = useState(false)
  const [openDropOffModal, setOpenDropOffModal] = useState(false)
  const [openSubmissionModal, setOpenSubmissionsModal] = useState(false)
  const [recommendation, setRecommendation] = useState(
    currentTrivvy.messagingRecommendationsText
  )
  const [insightsLoading, setInsightsLoading] = useState(false)
  const [surveyInsights, setSurveyInsights] = useState(
    currentTrivvy.surveyInsights || {}
  )
  const [selectedActions, setSelectedActions] = useState(
    currentTrivvy.selectedActions || []
  )
  const [shareActionsModal, setShareActionsModal] = useState({
    open: false,
    data: [],
  })
  const [missionValuesModal, setMissionValuesModal] = useState(false)

  const [isDownloadingInsights, setIsDownloadingInsights] = useState(false);

  const [uniqueUserCount, setUniqueUserCount] = useState(null);

  const [insightTabNo, setInsightTabNo] = useState(0)

  const [optimizeInsightsLoading, setOptimizeInsightsLoading] = useState(false)

  // Rating modal state
  const [ratingModal, setRatingModal] = useState({
    open: false,
    sectionIndex: null,
    categoryIndex: null,
    itemIndex: null,
    value: null,
    item: null
  })
  const [ratingFeedback, setRatingFeedback] = useState('')
  const [isSubmittingRating, setIsSubmittingRating] = useState(false)

  const [openRatingFor, setOpenRatingFor] = useState(null)

  // Implementation status state
  const [implementationDates, setImplementationDates] = useState({})
  const [implementationStatus, setImplementationStatus] = useState({}) // Track To Do / Done status
  const [openDatePickers, setOpenDatePickers] = useState({}) // Track which date pickers are open

  const currentPaymentPlan =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType

  console.log(user, '<<>>')

  const isMinpremiumPlan = minPlanLimitCheck(currentPaymentPlan, '003')

  // Check if it's a KC with retakes allowed
  const isKC = currentTrivvy && currentTrivvy.uploadType !== null && currentTrivvy.uploadType !== undefined;
  const hasRetakes = allowAttempts > 0;
  const showRetakesColumn = isKC && hasRetakes;

  // State for recalculated metrics when retakes are allowed
  const [recalculatedAvgScore, setRecalculatedAvgScore] = useState(null);
  const [recalculatedAvgTime, setRecalculatedAvgTime] = useState(null);



   const showPublishNotification = (heading) => {
      toastContainer(
        <div className="flex flex-column justify-content-center align-items-center">
          <span style={{ fontWeight: 500, fontSize: 16, marginBottom: 12, textAlign: 'center' }}>
            This Survey is still open. Are you sure you want  to share the outcome(s)?
          </span>
          <div className="flex justify-content-center align-items-center gap-3 mt-2">
            <button
              className="btn btn-success px-4 py-2 mx-2"
              style={{ borderRadius: 6, fontWeight: 500, fontSize: 15 }}
              onClick={() => {
                dismissToast()
                setShareActionsModal({
                  open: true,
                  data: selectedActions.filter((x) => x.parameter == heading),
                });
                
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-outline-secondary px-4 py-2 mx-2"
              style={{ borderRadius: 6, fontWeight: 500, fontSize: 15 }}
              onClick={() => {
                dismissToast()
              }}
            >
              No
            </button>
          </div>
        </div>,
        {
          background: 'rgb(238 250 236)',
          color: 'rgb(0, 83, 0)',
          fontSize: '15px',
          lineHeight: '1.85em',
          borderRadius: '0.5rem',
          boxShadow: 'rgb(38, 57, 70) 2px 14px 28px -6px',
          right: isMobile ? 0 : '85%',
          marginBottom: '0px',
        }
      );
    }

  // Fetch submissions and calculate unique user count, avg score, avg time (latest per user only)
  useEffect(() => {
    if (showRetakesColumn && surveyId) {
      axios
        .post(url.getTriviaSubmissions(surveyId))
        .then(({ data }) => {
          if (data && data.data && data.data.length > 0) {
            // Group by userId to get unique users (fallback to userData.email for external users)
            const userSubmissionsMap = {};
            data.data.forEach((submission) => {
              // Try userId._id first, then fallback to userData.email for external users
              const userKey = (submission.userId && submission.userId._id) || 
                              (submission.userData && submission.userData.email);
              if (userKey) {
                if (!userSubmissionsMap[userKey]) {
                  userSubmissionsMap[userKey] = [];
                }
                userSubmissionsMap[userKey].push(submission);
              }
            });

            // Keep only the latest submission per user
            const latestSubmissions = [];
            Object.values(userSubmissionsMap).forEach((submissions) => {
              const sortedSubmissions = submissions.sort((a, b) =>
                new Date(b.isSubmittedDate || b.createdOn) - new Date(a.isSubmittedDate || a.createdOn)
              );
              latestSubmissions.push(sortedSubmissions[0]);
            });

            setUniqueUserCount(latestSubmissions.length);

            // Calculate average score from latest submissions only
            let totalScore = 0;
            let scoreCount = 0;
            latestSubmissions.forEach((submission) => {
              if (submission.totalQuestions && submission.totalQuestions > 0) {
                const score = (submission.totalCorrect / submission.totalQuestions) * 100;
                totalScore += score;
                scoreCount++;
              }
            });
            const avgScore = scoreCount > 0 ? totalScore / scoreCount : 0;
            setRecalculatedAvgScore(avgScore);

            // Calculate average time from latest submissions only
            let totalTime = 0;
            let timeCount = 0;
            latestSubmissions.forEach((submission) => {
              if (submission.totalOverallTime && submission.totalOverallTime > 0) {
                totalTime += submission.totalOverallTime;
                timeCount++;
              }
            });
            const avgTime = timeCount > 0 ? totalTime / timeCount : 0;
            setRecalculatedAvgTime(avgTime);

          } else {
            setUniqueUserCount(0);
            setRecalculatedAvgScore(0);
            setRecalculatedAvgTime(0);
          }
        })
        .catch((err) => {
          console.log('Error fetching submissions:', err);
          setUniqueUserCount(null);
          setRecalculatedAvgScore(null);
          setRecalculatedAvgTime(null);
        });
    }
  }, [showRetakesColumn, surveyId]);

  // Helper function to get unique user count
  const getUniqueUserCount = () => {
    return uniqueUserCount || 0;
  };

  // Helper functions to get avg score and avg time (uses recalculated values when retakes allowed)
  const getAvgScore = () => {
    if (showRetakesColumn && recalculatedAvgScore !== null) {
      return recalculatedAvgScore;
    }
    return !showRetakesColumn && currentTrivvy && currentTrivvy.averageScore ? currentTrivvy.averageScore : 0;
  };

  const getAvgTime = () => {
    if (showRetakesColumn && recalculatedAvgTime !== null) {
      return recalculatedAvgTime;
    }
    return !showRetakesColumn && currentTrivvy && currentTrivvy.averageTime ? currentTrivvy.averageTime : 0;
  };

  useEffect(() => {
    setSurveyInsights(currentTrivvy.surveyInsights)
    setSelectedActions(currentTrivvy.selectedActions)
  }, [currentTrivvy])

  // Initialize implementation status and dates from server data
  useEffect(() => {
    if (currentTrivvy.surveyInsights && currentTrivvy.surveyInsights.surveyQuestionsInsights) {
      const newStatus = {}
      const newDates = {}
      
      currentTrivvy.surveyInsights.surveyQuestionsInsights.forEach((section, sectionIndex) => {
        if (section.data) {
          section.data.forEach((category, categoryIndex) => {
            if (category.items) {
              category.items.forEach((item, itemIndex) => {
                const key = `${sectionIndex}-${categoryIndex}-${itemIndex}`
                if (item.implementation) {
                  newStatus[key] = item.implementation.status === 'done'
                  newDates[key] = item.implementation.date ? moment(item.implementation.date) : null
                }
              })
            }
          })
        }
      })
      
      setImplementationStatus(newStatus)
      setImplementationDates(newDates)
    }
  }, [currentTrivvy.surveyInsights])

  const calculateAndDoubleDivCount = () => {
    const parentDiv = document.querySelector('.trivvy-res-insights-row.tprow')
    console.log('inside function-------')
    if (parentDiv) {
      console.log('104 IF statemnt-------')
      const childDivs = parentDiv.querySelectorAll('div.col-md-2')
      const count = childDivs.length
      console.log(`${count} ---- *****`)
      setDoubledDivCount(count * 2) // Double the count
    } else {
      setDoubledDivCount(8)
    }
  }

  const generateRecommendation = () => {
    setInsightsLoading(true)
    axios
      .get(url.getMessagingResponseRecommendations(currentTrivvy._id))
      .then(({ data }) => {
        setInsightsLoading(false)
        setRecommendation(data.data.generatedText)
      })
      .catch((err) => {
        setInsightsLoading(false)
        console.log(err)
      })
  }

  const handleSelectedAction = (action, heading) => {
    let actData = [...selectedActions]

    const index = actData.findIndex((x) => x.action == action)
    if (index >= 0) {
      actData.splice(index, 1)
    } else {
      actData.push({
        action,
        start_date: new Date(),
        share_date: new Date(),
        parameter: heading,
      })
    }

    axios
      .post(url.updateSelectedActionsForInsights, {
        triviaId: currentTrivvy._id,
        selectedActions: actData,
      })
      .then(({ data }) => {
        setSelectedActions(data.data.selectedActions)
        setCurrentTrivia({
          ...currentTrivvy,
          selectedActions: data.data.selectedActions,
        })
      })
      .catch((err) => {
        toastContainer(err.message, 'error')
      })
  }

  const handleDateChange = (value) => {
    const items = value.map((x) => new Date(x))
    setDateRange(items)
    if (items.length == 2 || items.length == 0) {
      getSummaryData({
        attempts: attemptNumber,
        dates: items,
      })
    }
  }
  const trivvyHasSingleTextQuestion =true;
  // const trivvyHasSingleTextQuestion =
  //   currentTrivvy && currentTrivvy.questions
  //     ? currentTrivvy.questions.filter((x) => x.question_type == 'TEXT')
  //         .length > 0
  //     : false

  const isMcQTrivvy =
    questions && questions.filter((x) => x.question_type == 'MCQ').length > 0
  const [summaryData, setSummaryData] = useState({})
  const getSummaryData = (filters) => {
    setSummaryApiLoading(true)
    axios
      .post(url.getTriviaInsightsSummary(surveyId), { filter: filters })
      .then(({ data }) => {
        console.log('data 236 result insights -- ', data)
        setSummaryApiLoading(false)
        let doc = { ...data.data }
        if (!doc.started_docs) {
          doc.started_docs = 0
        }
        if (!doc.submitted_docs) {
          doc.submitted_docs = 0
        }
        if (!doc.started_docs) {
          doc.started_docs = 0
        } else {
        }
        console.log('248 doc ---', doc)
        console.log(doc)
        setSummaryData(doc)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    calculateAndDoubleDivCount()
  }, [])

  let total_people_counts = currentTrivvy.isMessaging
    ? currentTrivvy.sharedWithUsers.length
    : 0


  if (summaryData && !currentTrivvy.isMessaging) {
    if (
      summaryData &&
      (summaryData.submitted_docs || summaryData.started_docs)
    ) {
      total_people_counts =
        summaryData.submitted_docs + summaryData.started_docs
    }
    total_people_counts = summaryData.submitted_docs + summaryData.started_docs
  } else if (currentTrivvy) {
    total_people_counts =
      currentTrivvy.startCount || currentTrivvy.totalSubmissions
  }

  const [isEndDateBeforeToday, setIsEndDateBeforeToday] = useState(false)

  useEffect(() => {
    if (currentTrivvy) {
      if (moment(currentTrivvy.trivvyEndDate).isSameOrBefore(moment(), 'day')) {
        setIsEndDateBeforeToday(true)
      }
    }
  }, [currentTrivvy])

  const trivvyPlanType =
    user && user.organizationId && user.organizationId.trivvyPlanType

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : 'N'
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
  }

  const consturctUserObjForExternalUser = (obj) => {
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: '[Email]-',
      }
    } else if (obj.name) {
      const arr = obj.name.split(' ')
      return {
        identification: '[Name]-',
        firstName: arr[0],
        lastName: arr[1] || '',
      }
    } else {
      return {
        identification: '[EmployeeId]-',

        firstName: obj.employeeId,
      }
    }
  }
  const renderUserName = (data) => {
    if (!data.isAnonymous) {
      if (data.userId && data.userId._id) {
        return (
          <span className="trivia_table_text_wrapper">
            {profilePicValidityCheck(data.userId.profilePic) ? (
              <img
                src={data.userId.profilePic}
                height="35px"
                width="35px"
                style={{ borderRadius: '50%' }}
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={getInitials(data.userId)}></span>
            )}{' '}
            {data.userId.firstName} {data.userId.lastName}
          </span>
        )
      } else if (data.userData) {
        return (
          <span>
            {consturctUserObjForExternalUser(data.userData).firstName}{' '}
            {consturctUserObjForExternalUser(data.userData).lastName}
          </span>
        )
      } else {
        return 'User'
      }
    } else {
      return 'Anonymous user'
    }
  }

  const isSurveyTrivvy = currentTrivvy.isBuiltInWithAiType

  const generateSurveyInsights = (isRegenerate) => {
    let enableGenerateInsights = false;
    if (currentTrivvy.allowAnonymousResponses) {
      enableGenerateInsights = currentTrivvy.totalSubmissions >= 5;
    } else {
      enableGenerateInsights = currentTrivvy.totalSubmissions > 0;
    }
    if(currentTrivvy && enableGenerateInsights){
      setInsightsLoading(true)
      axios
        .post(url.generateInsightsForTrivvyNonTextTypeQuestions, {
          triviaId: currentTrivvy._id,
          regenerate: isRegenerate ? true : false,
          oldText: surveyInsights ? surveyInsights.surveyQuestionsInsights : '',
        })
        .then(({ data }) => {
          setInsightsLoading(false)
          setSurveyInsights({
            ...surveyInsights,
            surveyQuestionsInsights: data.data.generatedText,
          })
          setSelectedActions([])
          setCurrentTrivia({
            ...currentTrivvy,
            surveyInsights: {
              ...surveyInsights,
              surveyQuestionsInsights: data.data.generatedText,
            },
            selectedActions: [],
          })
        })
        .catch((err) => {
          setInsightsLoading(false)
          console.log(err)
        })
    }
  }

  const optimizeSurveyInsights = () => {
    setOptimizeInsightsLoading(true)
    const modifiedData = surveyInsights.surveyQuestionsInsights.map((doc1) => {
      return {
        ...doc1,
        data: doc1.data.map((doc2) => {
          return {
            ...doc2,
            items: doc2.items.map((x) => {
              return {
                ...x,
                item: x.enhanced ? x.enhanced : x.item,
                ...(x.enhanced && {
                  enhanced: undefined,
                }),
              }
            }),
          }
        }),
      }
    })
    axios
      .post(url.generateInsightsForTrivvyNonTextTypeQuestions, {
        triviaId: currentTrivvy._id,
        regenerate: false,
        optimizeBasedOnOrgInfo: true,
        existingJsonInput: JSON.stringify(modifiedData),
      })
      .then(({ data }) => {
        setOptimizeInsightsLoading(false)
        setSurveyInsights({
          ...surveyInsights,
          surveyQuestionsInsights: data.data.generatedText,
          surveyQuestionsInsightsOptimized:
            data.data.surveyQuestionsInsightsOptimized,
        })
        setCurrentTrivia({
          ...currentTrivvy,
          surveyInsights: {
            ...surveyInsights,
            surveyQuestionsInsights: data.data.generatedText,
            surveyQuestionsInsightsOptimized:
              data.data.surveyQuestionsInsightsOptimized,
          },
        })
      })
      .catch((err) => {
        setOptimizeInsightsLoading(false)
        console.log(err)
      })
  }

  const getPercentCalculated = (v1, v2) => {
    if (v2 == 0) {
      return 0
    } else {
      return Math.round((v1 / v2) * 100)
    }
  }

  const calcSharedUsers = (trivvy) => {
    let len =
      trivvy.sharedWithUsers &&
      trivvy.sharedWithUsers.filter(
        (x) =>
          x.shareMediums && x.shareMediums.length && (x.emailDate || x.smsDate)
      ).length + (currentTrivvy.otherMediumsShareCount || 0)
      
    
    return len
  }
  
  function extractAndConvertToJSON(text) {
    const insights = []
    const regex = /### (.+?)\s*\n\d+\.\s*\*\*(.+?)\*\*\s*\n([\s\S]*?)(?=\n### |\n## |\Z)/g

    let match
    while ((match = regex.exec(text)) !== null) {
      const category = match[1].trim() // Main heading
      const subCategory = match[2].trim() // Subheading
      const items = match[3]
        .trim()
        .split('\n')
        .map((line) => line.replace(/^- /, '').trim()) // Remove bullet points
        .filter((line) => line) // Remove empty lines

      insights.push({ category, subCategory, items })
    }

    if (regex.exec(text) == null) {
      text = text.split('## Key Findings')[0]
      const insights = []
      const regex = /### (.*?)\n\*\*(.*?)\*\*\n([\s\S]*?)(?=(### |\Z))/g

      let match
      while ((match = regex.exec(text)) !== null) {
        const category = match[1].trim() // Main heading
        const subCategory = match[2].trim() // Subheading
        const items = match[3]
          .trim()
          .split('\n')
          .map((line) => line.replace(/^- /, '').trim()) // Remove bullet points
          .filter((line) => line) // Remove empty lines

        insights.push({ category, subCategory, items })
      }
      return insights
    }

    return insights
  }

  function removeActionableInsights(text) {
    const keyFindingsIndex = text.indexOf('## Key Findings')
    return text.slice(keyFindingsIndex)
  }

  const transformToHtml = (string) => {
    let newStr = removeActionableInsights(string)
    let m_down = marked.parse(newStr, {
      breaks: true,
    })

    console.log('e', extractAndConvertToJSON(string))
    return m_down
  }

  const mdParse = (newStr) => {
    let m_down = marked.parse(newStr, {
      breaks: true,
    })

    return parse(m_down)
  }


    console.log('**currentTrivvy', currentTrivvy)
  console.log('**summaryData', summaryData)
  console.log('**dateRange', dateRange, dateRange.length)


  const insightsBlocks = (hideBlocksForPDF) => {
    return (
      <div>
        <Row className={`mt-4 trivvy-res-insights-row tprow`}>
          <Col md={2}>
            <div className="insight_metrics_card2  responses">
              <div className="insight_metrics_card_icon_div  responses">
                <FaWpforms size={20} />
              </div>

              <div className="insight_metrics_card_numcount">
                <div>
                    <div>{currentTrivvy.insightsTotalCount && currentTrivvy.insightsTotalCount>0 ? currentTrivvy.insightsTotalCount : currentTrivvy.otherMediumsShareCount }</div>
                </div>
              </div>
              <div className="insight_metrics_card_title">
                Sent to{' '}
                {!hideBlocksForPDF && (
                  <OoPopover
                    target="insights_response_rate"
                    headerText="Sent to"
                    bodyText={`Total number of users who were sent the ${currentTrivvy.isMessaging ? 'message' : 'Trivvy'} via this platform, or were able to receive the ${currentTrivvy.isMessaging ? 'message' : 'Trivvy'} by other means.`}
                    css_class="oo_popover_insights_tip"
                  />
                )}
              </div>
            </div>
          </Col>
          <Col md={2}>
            <div className="insight_metrics_card2 completion">
              <div className="insight_metrics_card_icon_div completion">
                <FaBarsProgress size={20} />
              </div>

              <div className="insight_metrics_card_numcount">
                {dateRange.length < 2 || currentTrivvy.isMessaging ? (
                  <div
                    className={`${
                      currentTrivvy && currentTrivvy.totalSubmissions
                        ? 'cursor-pointer'
                        : ''
                    } count_text`}
                    onClick={() => {
                      if (currentTrivvy && currentTrivvy.totalSubmissions) {
                        setOpenSubmissionsModal(true)
                      }
                    }}>
                    {showRetakesColumn ? getUniqueUserCount() : (currentTrivvy.totalSubmissions || 0)}
                  </div>
                ) : (
                  <div
                    className={`${
                      summaryData && summaryData.submitted_docs
                        ? 'cursor-pointer'
                        : ''
                    } count_text`}
                    onClick={() => {
                      if (summaryData && summaryData.submitted_docs) {
                        setOpenSubmissionsModal(true)
                      }
                    }}>
                    {summaryApiLoading ? (
                      <SpinnerLoader />
                    ) : (
                      <div>
                        {showRetakesColumn ? getUniqueUserCount() : ((summaryData && summaryData.submitted_docs) || 0)}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="insight_metrics_card_title">
                Responses
                {!hideBlocksForPDF && (
                  <OoPopover
                    target="insights_responses"
                    headerText="Responses"
                    bodyText={`${currentTrivvy && currentTrivvy.isMessaging ? 'Total number of user responses to the initial Admin message.' : 'Total number of people who submitted a response.' }`}
                    css_class="oo_popover_insights_tip"
                  />
                )}
              </div>
            </div>
          </Col>

          {!currentTrivvy.isMessaging && (
            <Col md={2}>
              <div className="insight_metrics_card2 resprate">
                <div className="insight_metrics_card_icon_div resprate">
                  <FaRegThumbsUp size={20} />
                </div>

                <div className="insight_metrics_card_numcount">
                  {dateRange.length < 2 ? (
                    <div>
                      {getPercentCalculated(
                        showRetakesColumn ? getUniqueUserCount() : currentTrivvy.totalSubmissions,
                        currentTrivvy.insightsStartCount && currentTrivvy.insightsStartCount>0?currentTrivvy.insightsStartCount:currentTrivvy.startCount
                      )}
                      %
                    </div>
                  ) : (
                    <div>
                      {getPercentCalculated(
                        summaryData.submitted_docs,
                        summaryData.started_docs
                      )}
                      %
                    </div>
                  )}
                </div>

                <div className="insight_metrics_card_title">
                  Response rate{' '}
                  {!hideBlocksForPDF && (
                    <OoPopover
                      target="insights_response_rate"
                      headerText="Response rate"
                      bodyText= "Total number of people who responded / Total number of people who were sent the Trivvy via this platform, or were able to start the Trivvy by other means."
                      css_class="oo_popover_insights_tip"
                    />
                  )}
                </div>
              </div>
            </Col>
          )}

         
          {!currentTrivvy.isMessaging && (
            <Col md={2}>
              <div className="insight_metrics_card2 avgtime">
                <div className="insight_metrics_card_icon_div avgtime">
                  <FaClock size={20} />
                </div>

                <div className="insight_metrics_card_numcount">
                  {dateRange.length < 2 ? (
                    <div>
                      {formatDuration(
                        Math.round(getAvgTime())
                      )}
                    </div>
                  ) : (
                    <div>
                      {formatDuration(
                        Math.round(summaryData.total_avg_time || 0)
                      )}
                    </div>
                  )}
                </div>
                <div className="insight_metrics_card_title">
                  Avg Time
                  {!hideBlocksForPDF && (
                    <OoPopover
                      target="insights_avg_time"
                      headerText="Average time"
                      bodyText="Average Time it took to respond across all responses"
                      css_class="oo_popover_insights_tip"
                    />
                  )}
                </div>
              </div>
            </Col>
          )}

          {currentTrivvy &&
          getAvgScore() > 0 ? (
            <Col md={2}>
              <div className="insight_metrics_card2">
                {/* <div className="insight_metrics_card2_title">
                      avg score
                    </div> */}
                <div className="insight_metrics_card_icon_div avgscore">
                  <FaCheck size={20} />
                </div>
                <div className="mt-3 insight_metrics_card_numcount">
                  {dateRange.length < 2 ? (
                    <div className="">
                      <span>
                        {Math.round(getAvgScore()) || 0}
                        %
                      </span>
                    </div>
                  ) : (
                    <div className="">
                      {summaryApiLoading ? (
                        <SpinnerLoader />
                      ) : (
                        <span>
                          {summaryData && summaryData.total_avg_score
                            ? Math.round(summaryData.total_avg_score)
                            : 0}{' '}
                          %
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="insight_metrics_card_title">
                  avg score
                  {!hideBlocksForPDF && (
                    <OoPopover
                      target="insights_avg_score"
                      headerText="Average score"
                      bodyText="Average score across all who responded"
                      css_class="oo_popover_insights_tip"
                    />
                  )}
                </div>
              </div>
            </Col>
          ) : null}

        {/* { !currentTrivvy.isMessaging?
          <Col md={2}>
            <div className="insight_metrics_card2">
              <div className={`insight_metrics_card_icon_div avgrating${
                  currentTrivvy.averageRating || summaryData.total_avg_rating
                    ? ''
                    : 'Zero'
                }`}>
                {currentTrivvy.averageRating || summaryData.total_avg_rating ? (
                  <FaStar size={20} />
                ) : (
                  <FaStar color="#c2c2be" size={20} />
                )}
              </div>
              {currentTrivvy.averageRating || summaryData.total_avg_rating ? (
                <div className="mt-3 insight_metrics_card_numcount">
                  {dateRange.length < 2 ? (
                    <div>
                      <StarRatings starDimension="8px" starRatedColor={"#F8D748"} numberOfStars={5} rating={Math.round(currentTrivvy.averageRating)} />
                      {Math.round(currentTrivvy.averageRating)}
                    </div>
                  ) : (
                    <div>
                      <StarRatings starDimension="8px" starRatedColor={"#F8D748"} numberOfStars={5} rating={Math.round(summaryData.total_avg_rating)} />
                      {Math.round(summaryData.total_avg_rating)}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="insight_metrics_card_numcount"
                  style={{
                    opacity: 0.7,
                    fontSize: '1.3rem',
                    paddingTop: '8px',
                  }}>
                  No Ratings
                </div>
              )}

              <div className="insight_metrics_card_title">
                avg rating
                {!hideBlocksForPDF && (
                  <OoPopover
                    target="insights_avg_rating"
                    headerText="Average rating"
                    bodyText="Average Trivvy rating given by all respondents"
                    css_class="oo_popover_insights_tip"
                  />
                )}
              </div>
            </div>
          </Col>: null} */}
        </Row>

        { currentTrivvy.isMessaging && (
          <Card className="p-3 mt-5">
            {/* <div>
              {" "}
              <h5>Message Title: </h5>
              <div>
                {" "}
                {trivia.name ? trivia.name : `No title`} */}
                {/* `${trivia.messagingSubject.slice(0, 10)}...` */}
              {/* </div>
            </div> */}
            <h5>
              <strong>{currentTrivvy.name ? currentTrivvy.name : "No title"}:</strong> {currentTrivvy.messagingSubject ? currentTrivvy.messagingSubject : 'No message content'}
            </h5>
            {/* <div className="mt-4">
              <h5>Message Content:</h5>
              {trivia.messagingSubject}
            </div> */}
          </Card>
          )
        }

        <Row className="pt-5 trivvy-res-insights-row">

          {trivvyHasSingleTextQuestion && currentTrivvy.totalSubmissions > 0 && (
            <Col md={12}>
              <div className="insight_metrics_card2 trivvy-res-insights-sent-container">
                <div className="insight_metrics_card2_title">
                  Sentiment Analysis {' '}
                  {!hideBlocksForPDF && (
                    <OoPopover
                      target="sentiment_analysis"
                      headerText={'Sentiments'}
                      bodyText={
                        <div className='flex flex-column'>
                          {
                            !currentTrivvy.isMessaging ? <span className='mb-3'>Sentiment Analysis is only generated on responses to open text questions.</span>
                            : null
                          }
                          <ul className="sentiment-analysis-info-popup-container-list">
                            <li>
                              <b className="sentiment-analysis_positive">
                                {' '}
                                <BsEmojiSmile /> Positive:
                              </b>{' '}
                              The response expresses an overall positive sentiment.
                            </li>
                            <li>
                              <b className="sentiment-analysis_neutral">
                                {' '}
                                <BsEmojiFrown /> Neutral:
                              </b>{' '}
                              The response does not express either positive or
                              negative sentiments.
                            </li>
                            <li className="">
                              <b className="sentiment-analysis_negative">
                                <BsEmojiNeutral />
                                Negative:
                              </b>{' '}
                              The response expresses an overall negative sentiment.
                            </li>
                            <li>
                              <b className="sentiment-analysis_mixed">
                                {' '}
                                <FaRegFaceMehBlank /> Mixed:
                              </b>{' '}
                              The response expresses both positive and negative
                              sentiments.
                            </li>
                          </ul>
                        </div>
                      }
                      css_class="oo_popover_insights_tip"
                    />
                  )}
                </div>

                {trivvyHasSingleTextQuestion && (
                  <div className="insight_metrics_card2_count">
                    <div className="piechart-wrapper-sentiments">
                      {summaryApiLoading ? (
                        <SpinnerLoader />
                      ) : dateRange.length < 2 ? (
                        <div>
                          {currentTrivvy.allowAnonymousResponses && currentTrivvy.averageSentimentsScore && currentTrivvy.totalSubmissions <=5  ? (
                             <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop:'10px',
                              fontSize:'18px'
                            }}
                            >  Too few responses to maintain anonymity
                            </div>

                          ) : (
                               <TextSentimentComponentOverall
                          blockModal={currentTrivvy.isMessaging ?  true :false}
                            data={currentTrivvy.averageSentimentsScore}
                            totalSumOfNumResponses={
                              currentTrivvy.totalSubmissions
                            }
                            totalSentimentCounts={
                              currentTrivvy.totalSentimentCounts
                            }
                            currentTrivvy={currentTrivvy}
                            user={user}
                          />
                          ) }
                       
                        </div>
                      ) : dateRange.length > 0 &&
                        summaryData &&
                        summaryData.sentiment_data ? (
                        <div>

                          {currentTrivvy.allowAnonymousResponses && currentTrivvy.averageSentimentsScore && currentTrivvy.totalSubmissions <=5  ? (
                            <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop:'10px',
                              fontSize:'18px'
                            }}
                            > Too few responses to maintain anonymity
                            </div>

                          ) : (
                          <TextSentimentComponentOverall
                          blockModal={currentTrivvy.isMessaging ?  true :false}
                            data={summaryData.sentiment_data}
                            totalSumOfNumResponses={summaryData.submitted_docs}
                            totalSentimentCounts={
                              currentTrivvy.totalSentimentCounts
                            }
                            currentTrivvy={currentTrivvy}
                          />)}
                        </div>
                      ) : (
                        <div className="mt-3 insight_metrics_card_numcount">
                          NA
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          )}
        </Row>
      </div>
    )
  }

  // const handleDownload = async () => {
  //   setIsDownloadingInsights(true);

  //   const data = await document.querySelector('#jspdf_export_insight')

  //   const pdf = window.html2pdf().from(data)

  //   pdf.then(async () => {
  //     pdf.save(
  //       `${moment(new Date()).format(
  //         'dddd, MMMM Do YYYY, h:mm:ss a'
  //       )} - Trivvy Insights.pdf`
  //     )
  //   })
  // }

  const handleDownload = async () => {
    setIsDownloadingInsights(true);
  
    const data = document.querySelector('#jspdf_export_insight');

    // Remove previous header if exists
    const existingHeader = data.querySelector('.export-header');
    if (existingHeader) {
      existingHeader.remove();
    }

    // Create new header
    const headerDiv = document.createElement("div");
    headerDiv.className = "export-header"; // Add identifiable class
    headerDiv.style.marginBottom = "40px";
    headerDiv.style.textAlign = "center";

    const title = document.createElement("h1");
    title.style.margin = "0";
    title.innerText = currentTrivvy.name || "Trivvy";

    const subtitle = document.createElement("p");
    subtitle.style.margin = "0";
    subtitle.innerText = `Exported on: ${moment().format("MMMM Do YYYY")}`;

    headerDiv.appendChild(title);
    headerDiv.appendChild(subtitle);

    // Inject header at the top of export container
    data.prepend(headerDiv);
    data.style.display = 'block';
  
    // Wait for DOM update
    await new Promise((resolve) => requestAnimationFrame(resolve));
  
    // Generate PDF
    await window.html2pdf()
      .from(data)
      .set({
        margin: [0.5, 0.2, 0.5, 0.2],
        filename: `${moment().format('dddd, MMMM Do YYYY')} - ${currentTrivvy.name || "Trivvy"} Insights.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: {
          unit: 'in',
          format: 'letter',
          orientation: 'portrait',
        },
      })
      .save();
  
    data.style.display = 'none';
    setIsDownloadingInsights(false);
  };




  const handleActionChangeUpdate = (
    insightsUpdated,
    selectedActionsUpdated
  ) => {
    const actionsArray = [...selectedActionsUpdated]

    const newSurveyInsights = {
      ...surveyInsights,
      surveyQuestionsInsights: insightsUpdated,
    }

    axios
      .put(url.editTrivia(currentTrivvy._id), {
        updateData: {
          selectedActions: actionsArray,
          surveyInsights: newSurveyInsights,
        },
      })
      .then(({ data }) => {
        setCurrentTrivia({
          ...currentTrivvy,
          ...{
            selectedActions: data.data.trivia.selectedActions,
            surveyInsights: data.data.trivia.surveyInsights,
          },
        })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error while updating selected actions', 'error')
      })
  }

  const handleActionChange = (
    value,
    docIndex,
    catIndex,
    itemIndex,
    selectedActionObjIndex
  ) => {
    const oldData = [...surveyInsights.surveyQuestionsInsights]
    const seletcedActs = [...selectedActions]

    if (seletcedActs[selectedActionObjIndex]) {
      seletcedActs[selectedActionObjIndex].action = value
    }

    oldData[docIndex].data[catIndex].items[itemIndex] = {
      ...oldData[docIndex].data[catIndex].items[itemIndex],
      item: value,
    }

    setSurveyInsights({
      ...surveyInsights,
      surveyQuestionsInsights: oldData,
    })

    debounceFn(oldData, seletcedActs)
  }
  const handleActionChangeForEnhancedText = (
    value,
    docIndex,
    catIndex,
    itemIndex,
    selectedActionObjIndex
  ) => {
    const oldData = [...surveyInsights.surveyQuestionsInsights]
    const seletcedActs = [...selectedActions]

    if (seletcedActs[selectedActionObjIndex]) {
      seletcedActs[selectedActionObjIndex].action = value
    }

    oldData[docIndex].data[catIndex].items[itemIndex] = {
      ...oldData[docIndex].data[catIndex].items[itemIndex],
      enhanced: value,
    }

    setSurveyInsights({
      ...surveyInsights,
      surveyQuestionsInsights: oldData,
    })

    debounceFn(oldData, seletcedActs)
  }

  const debounceFn = useCallback(_debounce(handleActionChangeUpdate, 1000), [])

  // Rating handlers
  const handleRatingClick = (sectionIndex, categoryIndex, itemIndex, value, item) => {
    setRatingModal({
      open: true,
      sectionIndex,
      categoryIndex,
      itemIndex,
      value,
      item
    })
    // Pre-fill feedback if there's an existing reason
    const existingReason = item.rating && item.rating.reason ? item.rating.reason : ''
    setRatingFeedback(existingReason)
  }

  // Implementation handlers
  const handleImplementationUpdate = async (sectionIndex, categoryIndex, itemIndex, type, value) => {
    const key = `${sectionIndex}-${categoryIndex}-${itemIndex}`

    try {
      const implementationData = type === 'status'
        ? { status: value ? 'done' : 'todo' }
        : { date: value ? value.toISOString() : null }

      const response = await axios.put(url.updateSurveyInsightImplementationStatus(currentTrivvy._id), {
        triviaId: currentTrivvy._id,
        sectionIndex,
        categoryIndex,
        itemIndex,
        implementation: implementationData
      })

      if (response.data) {
        // Update local state based on type
        if (type === 'status') {
          setImplementationStatus(prev => ({
            ...prev,
            [key]: value
          }))
        } else {
          setImplementationDates(prev => ({
            ...prev,
            [key]: value ? moment(value).startOf('day') : null
          }))
        }

        // Update only the specific implementation field in surveyInsights to avoid overwriting other fields like rating or share_date
        const updatedSurveyInsights = { ...currentTrivvy.surveyInsights }
        if (updatedSurveyInsights.surveyQuestionsInsights &&
            updatedSurveyInsights.surveyQuestionsInsights[sectionIndex] &&
            updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data &&
            updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex] &&
            updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex].items &&
            updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex].items[itemIndex]) {

          updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex].items[itemIndex] = {
            ...updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex].items[itemIndex],
            implementation: {
              ...updatedSurveyInsights.surveyQuestionsInsights[sectionIndex].data[categoryIndex].items[itemIndex].implementation,
              ...implementationData
            }
          }
        }

        setCurrentTrivia({
          ...currentTrivvy,
          surveyInsights: updatedSurveyInsights
        })

        toastContainer(`${type === 'status' ? 'Status' : 'Date'} updated successfully!`, 'success')
      }
    } catch (error) {
      console.error(`Error updating ${type}:`, error)
      const errorMessage = (error.response && error.response.data && error.response.data.message) || `Failed to update ${type}`
      toastContainer(errorMessage, 'error')
    }
  }

  const handleStatusToggle = async (sectionIndex, categoryIndex, itemIndex) => {
    const key = `${sectionIndex}-${categoryIndex}-${itemIndex}`
    const newStatus = !implementationStatus[key] // Toggle between true (Done) and false/undefined (To Do)
    await handleImplementationUpdate(sectionIndex, categoryIndex, itemIndex, 'status', newStatus)
  }

  const handleImplementationDateChange = async (sectionIndex, categoryIndex, itemIndex, date) => {
    await handleImplementationUpdate(sectionIndex, categoryIndex, itemIndex, 'date', date)
  }

  const handleCloseRatingModal = () => {
    // Submit rating with current feedback value (even if empty)
    if (ratingModal.open) {
      submitRating(ratingFeedback || null)
    }
  }

  const handleSubmitRating = () => {
    submitRating(ratingFeedback)
  }

  const submitRating = async (reason) => {
    setIsSubmittingRating(true)
    try {
      const response = await axios.post(url.rateSurveyInsight, {
        triviaId: currentTrivvy._id,
        sectionIndex: ratingModal.sectionIndex,
        categoryIndex: ratingModal.categoryIndex,
        itemIndex: ratingModal.itemIndex,
        value: ratingModal.value,
        reason: reason || null
      })
      if (response.data.meta.success) {
        // Update only the rating for the specific item, preserving other properties like share_date
        const updatedSurveyInsights = { ...surveyInsights };
        
        // Ensure the structure exists
        if (!updatedSurveyInsights.surveyQuestionsInsights) {
          updatedSurveyInsights.surveyQuestionsInsights = [];
        }
        if (!updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex]) {
          updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex] = { data: [] };
        }
        if (!updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex]) {
          updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex] = { items: [] };
        }
        if (!updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex].items[ratingModal.itemIndex]) {
          updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex].items[ratingModal.itemIndex] = {};
        }

        // Preserve existing properties and update only the rating
        const existingItem = updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex].items[ratingModal.itemIndex];
        const newRating = response.data.data.surveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex].items[ratingModal.itemIndex].rating;
        
        updatedSurveyInsights.surveyQuestionsInsights[ratingModal.sectionIndex].data[ratingModal.categoryIndex].items[ratingModal.itemIndex] = {
          ...existingItem,
          rating: newRating
        };

        setSurveyInsights(updatedSurveyInsights);
        
        // Update currentTrivvy as well
        setCurrentTrivia({
          ...currentTrivvy,
          surveyInsights: updatedSurveyInsights
        })

        toastContainer(
          'Rating saved successfully!',
          'success'
        )
      }
    } catch (error) {
      console.error('Error saving rating:', error)
      const errorMessage = error.response && error.response.data && error.response.data.data && error.response.data.data.message 
        ? error.response.data.data.message 
        : 'Failed to save rating'
      toastContainer(
        errorMessage,
        'error'
      )
    } finally {
      setIsSubmittingRating(false)
      setRatingModal({
        open: false,
        sectionIndex: null,
        categoryIndex: null,
        itemIndex: null,
        value: null,
        item: null
      })
      setRatingFeedback('')
    }
  }

  const handleDownloadInsightsTables = async (index, name) => {
    const data = await document.querySelector(
      `#download_insights_data_${index}`
    )

    const pdf = window.html2pdf().from(data)

    console.log({ pdf: data })

    pdf.then(async () => {
      pdf.save(
        `${moment(new Date()).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        )} - ${name}.pdf`
      )
    })
  }

  const renderInsightsUI = (data) => {
    if (typeof data == 'string') {
      return parse(data)
    } else {
      const insightsJSON = data

      const doc = insightsJSON[insightTabNo]
      const docIndex = insightTabNo

      const htmlData =
        insightsJSON && insightsJSON.length && doc ? (
          <div
            className={
              surveyInsights &&
              surveyInsights.surveyQuestionsInsightsOptimized &&
              docIndex != 1
                ? 'insights_action_table_ui'
                : ''
            }>
            {missionValuesModal && (
              <TrivvyEnterpriseConfigsModal
                open={missionValuesModal}
                onClose={() => {
                  setMissionValuesModal(false)
                }}
                onUpdateSuccess={optimizeSurveyInsights}
                heading="Tailored Actions?"
              />
            )}

<div className="d-flex my-4" style={{justifyContent:"flex-start", gap: '1em'}}>
            <Button
                onClick={() => setInsightTabNo(0)}
                className={`insight_action_category_button ${
                  insightTabNo == 0 ? 'active' : ''
                }`}>
                Key Findings <BsFileBarGraph />
              </Button>
              {/* <Button
                onClick={() => setInsightTabNo(1)}
                className={`insight_action_category_button ${
                  insightTabNo == 1 ? 'active' : ''
                }`}>
               Recommended Actions <GiNotebook />
              </Button> */}
              <Button
                onClick={() => setInsightTabNo(1)}
                className={`insight_action_category_button ${
                  insightTabNo == 1 ? 'active' : ''
                }`}>
                Suggested Next Steps <IoCalendarOutline />
              </Button>
            </div>

            <div style={{ display: 'none' }}>
              <div>
                {insightsJSON.map((doc, idx) => {
                  return (
                    <div
                      id={`download_insights_data_${idx}`}
                      style={{ width: '750px', margin: '20px 5px' }}>
                      <h3>{doc.heading}</h3>
                      <div>
                        {doc.data &&
                          doc.data.map((doc2, ind) => {
                            return (
                              <div>
                                {/* <h5>{doc2.category}</h5> */}
                                <div className="mt-2 ml-2">
                                <Table bordered className="ml-2 mt-2">
                                    <thead>
                                      <tr>
                                        <th></th>
                                        <th>{doc2.category}</th>
                                        {/* {surveyInsights &&
                                        surveyInsights.surveyQuestionsInsightsOptimized &&
                                        docIndex != 1 ? (
                                          <th>Tailored Approach</th>
                                        ) : null} */}
                                        {/* <th style={{ width: "20%" }}>Date</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {doc2.items.map((x, itemIndex) => {
                                        const selectedActionObjIndex = selectedActions.findIndex(
                                          (y) => y.action == x.item
                                        )
                                        const selectedActionObj =
                                          selectedActions[
                                            selectedActionObjIndex
                                          ]
                                        return (
                                          <tr>
                                            <td>
                                              {' '}
                                              <input
                                                checked={
                                                  selectedActionObj != null
                                                }
                                                type={'checkbox'}
                                                onChange={() => {
                                                  handleSelectedAction(
                                                    x.item,
                                                    doc.heading
                                                  )
                                                }}
                                                className="mt-2"
                                              />{' '}
                                            </td>
                                            <td>{roundPercentagesInText(x.item)}</td>
                                            {surveyInsights &&
                                            surveyInsights.surveyQuestionsInsightsOptimized &&
                                            docIndex != 1 ? (
                                              <td className="">{roundPercentagesInText(x.enhanced)}</td>
                                            ) : null}
                                          </tr>
                                        )
                                      })}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <div key={doc.heading}>
              <div className="d-flex justify-content-between">
                {/* <h6>{doc.heading}:</h6>{' '} */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {/* {docIndex != 1 && (
                    <Button
                      color="success"
                      onClick={() => {
                        if (
                          user &&
                          user.organizationId &&
                          (user.organizationId.mission ||
                            user.organizationId.values)
                        ) {
                          optimizeSurveyInsights(doc)
                        } else {
                          setMissionValuesModal(true)
                        }
                      }}
                      style={{
                        ...(isMinpremiumPlan
                          ? {}
                          : {
                              opacity: 0.6,
                              pointerEvents: 'none',
                            }),
                      }}
                      className="float-right ml-3">
                      {isMinpremiumPlan
                        ? 'Tailor Insights'
                        : 'Tailor Insights (Upgrade)'}
                    </Button>
                  )} */}

                  {selectedActions &&
                    selectedActions.filter((x) => x.parameter == doc.heading)
                      .length > 0 && (() => {
                        // Sanitize heading for id and target
                        const safeHeading = doc.heading.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '');
                        const btnId = `share-actions-btn-${safeHeading}`;
                        return (
                          <span style={{position: 'relative', display: 'flex', alignContent: 'center', marginRight: '4px'}}>
                            <Button
                              color="primary"
                              id={btnId}
                              onClick={() => {
                                  if(currentTrivvy && currentTrivvy.trivvyEndDate == null) {
                                      showPublishNotification(doc.heading)
                                  } else {
                                  setShareActionsModal({
                                  open: true,
                                  data: selectedActions.filter(
                                    (x) => x.parameter == doc.heading
                                  ),
                                })
                                  }    
                              }
                              }
                              className="float-right">
                              Share <BsShare />
                            </Button>
                            <OoPopover
                              target={btnId}
                              headerText="Share Outcome(s)"
                              bodyText="The outcome(s) you select will be shared with all users who received the Trivvy via this platform."
                            />
                          </span>
                        );
                      })()}

                  <UncontrolledDropdown>
                    <DropdownToggle color="info">
                      Settings <BsGear />
                    </DropdownToggle>

                    <DropdownMenu>
                      {/* <DropdownItem
                        onClick={() => {
                          handleDownloadInsightsTables(
                            0,
                            insightsJSON[0].heading
                          )
                        }}>
                        Download Actions
                      </DropdownItem> */}
                      <DropdownItem
                        onClick={() => {
                          handleDownloadInsightsTables(
                            0,
                            insightsJSON[0].heading
                          )
                        }}>
                        Download Key Findings
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          handleDownloadInsightsTables(
                            1,
                            insightsJSON[1].heading
                          )
                        }}>
                        Download Suggested Next Steps
                      </DropdownItem>
                      {/* <DropdownItem
                        onClick={() => {
                          setMissionValuesModal(true)
                        }}>
                        Edit Mission and Values
                      </DropdownItem> */}
                    </DropdownMenu>
                  </UncontrolledDropdown>


                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '-8px' }}>
                              <Button
                                outline
                                onClick={() => generateSurveyInsights(true)}
                                // className= {(enableGenerateInsights) ? "generate_insights_btn":"no_generate_insights_btn"} 
                                className={`${enableGenerateInsights ? 'trivia-action-button-main mr-1 ml-4 trivv-create-btn mt-2 create-trivvy-btn-itm h-generate_insights_btn' : 'no_generate_insights_btn'}`}
                                size="lg"
                                disabled={!enableGenerateInsights}
                              >
                                <span style={{color: '#fff', fontSize: '16px'}}>Regenerate Findings and Next Steps</span>
                                
                                <span className="ml-2">
                                  {" "}
                                  <BiRecycle />{" "}
                                </span>{" "}
                              </Button>
                              <OoPopover
                                target="regenerate-insights-popover"
                                placement="right"
                                headerText="Regenerate Findings and Next Steps"
                                bodyText={`Insights are always based on overall submissions (i.e. can not be filtered). Also insights about open text questions can be found in "By Question" Tab.`}
                              />
                </div>
                </div>
              </div>

              {doc.data && doc.data.length ? (
                <div className="ml-0">
                  {doc.data.map((item, catIndex) => {
                    return (
                      <div key={item.category}>
                        {/* <h3>{item.category}</h3> */}
                        {/* <h5 className="ml-2">{item.subCategory}</h5> */}
                        <div className="mt-2">
                          {optimizeInsightsLoading ? (
                            <Alert color="success">
                              Insights being tailored...
                            </Alert>
                          ) : (
                            ''
                          )}
                        </div>
                        <Table bordered className="ml-0 mt-2 custom-insights-table">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={(() => {
                                    const allItems = item.items.filter(i => i && i.item !== undefined);
                                    if (allItems.length === 0) return false;
                                    return allItems.every(i =>
                                      selectedActions.some(a => a.parameter === doc.heading && a.action === (i.enhanced && docIndex != 1 ? i.enhanced : i.item))
                                    );
                                  })()}
                                  onChange={e => {
                                    const checked = e.target.checked;
                                    const allItems = item.items.filter(i => i && i.item !== undefined);
                                    let newSelectedActions = [...selectedActions];
                                    if (checked) {
                                      allItems.forEach(i => {
                                        const actionValue = i.enhanced && docIndex != 1 ? i.enhanced : i.item;
                                        if (!newSelectedActions.some(a => a.parameter === doc.heading && a.action === actionValue)) {
                                          newSelectedActions.push({
                                            action: actionValue,
                                            start_date: new Date(),
                                            share_date: new Date(),
                                            parameter: doc.heading,
                                          });
                                        }
                                      });
                                    } else {
                                      // Remove all for this table/category
                                      newSelectedActions = newSelectedActions.filter(a => a.parameter !== doc.heading || !allItems.some(i => (i.enhanced && docIndex != 1 ? i.enhanced : i.item) === a.action));
                                    }
                                    setSelectedActions(newSelectedActions);
                                  }}
                                  style={{ marginLeft: '3px', cursor: 'pointer' }}
                                  title={`Check/uncheck all for ${item.category}`}
                                />
                              </th>
                              <th style={{ fontWeight: 600, color: '#000' }}>
                                {item.category}
                                {/* {docIndex==0?'Original Action':docIndex==1?'Original Finding':docIndex==2?'Original Next Step':''} */}
                              </th>
                              {doc.heading === 'Suggested Next Steps' && (
                                <th style={{ width: "100px", textAlign: "center", fontWeight: 600, color: '#000' }}>Status</th>
                              )}
                              {doc.heading === 'Suggested Next Steps' && (
                                <th style={{ width: "140px", textAlign: "center", fontWeight: 600, color: '#000' }}>Implemented</th>
                              )}
        
                              <th style={{ width: "140px", textAlign: "center", fontWeight: 600, color: '#000' }}>Share Date</th>
                   
                  
                       
                  
                              {/* Rating column header - only show for "Suggested Next Steps" section */}
                              {doc.heading === 'Suggested Next Steps' && (
                                <th style={{ maxWidth: "90px", textAlign: "center", fontWeight: 600, color: '#000' }}>Rating</th>
                              )}
                              {/* Status column header - only show for "Suggested Next Steps" section */}
                            
                              {/* {surveyInsights &&
                              surveyInsights.surveyQuestionsInsightsOptimized &&
                              docIndex != 1 ? (
                                <th>{docIndex==0?'Tailored Approach':docIndex==1?'Tailored Finding':docIndex==2?'Tailored Next Step':''}</th>
                              ) : null} */}
                              {/* <th style={{ width: "20%" }}>Date</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {item.items.map((x, itemIndex) => {

                              const selectedActionObjIndex = selectedActions.findIndex(
                                (y) => x.enhanced&&docIndex != 1?y.action == x.enhanced:y.action==x.item
                              )

                              const selectedActionObj =
                                selectedActions[selectedActionObjIndex]
                              
                              // Check if this item has a rating
                              const hasRating = x.rating && x.rating.value
                              const ratingValue = x.rating && x.rating.value ? x.rating.value : null
                              
                              return (
                                <tr className={selectedActionObj != null ? 'selected-row' : ''}>
                                  <td>
                                    {' '}
                                    <input
                                      checked={selectedActionObj != null}
                                      type={'checkbox'}
                                      onChange={(e) => {
                                        const insight=x.enhanced&&docIndex != 1?x.enhanced:x.item
                                        handleSelectedAction(
                                          insight,
                                          doc.heading
                                        )
                                      }}
                                      className="mt-2 custom-checkbox"
                                    />{' '}
                                  </td>
                                  <td>
                                    <Input
                                      type="textarea"
                                      rows={
                                        docIndex == 1
                                          ? 1
                                          : surveyInsights.surveyQuestionsInsightsOptimized
                                          ? 4
                                          : 2
                                      }
                                      className="border-none table-input"
                                      value={roundPercentagesInText(x.item)}
                                      onChange={(e) =>
                                        handleActionChange(
                                          e.target.value,
                                          docIndex,
                                          catIndex,
                                          itemIndex,
                                          selectedActionObjIndex
                                        )
                                      }
                                      style={{
                                        minWidth: isMobile ? '100px' : '400px',
                                      }}
                                    />
                                  </td>


                               
                                 
                                  {/* Status column - only show for "Suggested Next Steps" section */}
                                  {doc.heading === 'Suggested Next Steps' && (
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                      <Button
                                        color={implementationStatus[`${docIndex}-${catIndex}-${itemIndex}`] ? 'success' : 'secondary'}
                                        size="sm"
                                        onClick={() => handleStatusToggle(docIndex, catIndex, itemIndex)}
                                      >
                                       <span style={{fontSize: '16px'}}>{implementationStatus[`${docIndex}-${catIndex}-${itemIndex}`] ? 'Done' : 'To Do'}</span> 
                                      </Button>
                                    </td>
                                  )}

                                  {/* Implementation column - only show for "Suggested Next Steps" section */}
                                  {doc.heading === 'Suggested Next Steps' && (
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                      {openDatePickers[`${docIndex}-${catIndex}-${itemIndex}`] ? (
                                        <DatePicker
                                          dateFormat="MMM DD, YYYY"
                                          placeholderText="Enter date: MMM DD, YYYY"
                                          className="form-control filter-action-date-input"
                                          selected={implementationDates[`${docIndex}-${catIndex}-${itemIndex}`]}
                                          onChange={(v) => {
                                            handleImplementationDateChange(docIndex, catIndex, itemIndex, v)
                                            setOpenDatePickers({
                                              ...openDatePickers,
                                              [`${docIndex}-${catIndex}-${itemIndex}`]: false
                                            })
                                          }}
                                          onBlur={() => {
                                            setOpenDatePickers({
                                              ...openDatePickers,
                                              [`${docIndex}-${catIndex}-${itemIndex}`]: false
                                            })
                                          }}
                                          showYearDropdown
                                          autoFocus
                                        />
                                      ) : implementationDates[`${docIndex}-${catIndex}-${itemIndex}`] ? (
                                        <span style={{fontSize: '16px', color: "#54555f", fontWeight: 400}}>
                                          {moment(implementationDates[`${docIndex}-${catIndex}-${itemIndex}`]).format("MMM D, YYYY")}
                                        </span>
                                      ) : (
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                          <IoCalendarOutline 
                                            size={20} 
                                            color="#6c757d" 
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setOpenDatePickers({
                                              ...openDatePickers,
                                              [`${docIndex}-${catIndex}-${itemIndex}`]: true
                                            })}
                                          />
                                        </div>
                                      )}
                                    </td>
                                  )}
                      
                                <td style={{fontSize: '15.5px', color: "#54555f", fontWeight: 400, textAlign: 'center'}}>
                                      {x.share_date
                                        ? moment(x.share_date).format("MMM D, YYYY")
                                        : "--"}
                                    </td>
                             
                                  {/* Rating buttons - only show for "Suggested Next Steps" section */}
                                  {doc.heading === 'Suggested Next Steps' && (
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                      {openRatingFor === `${docIndex}-${catIndex}-${itemIndex}` ? (
                                        <div style={{ display: "flex", justifyContent: "center", marginTop: '-4px' }}>
                                          <button
                                            onClick={() => {
                                              handleRatingClick(docIndex, catIndex, itemIndex, 1, x);
                                              setOpenRatingFor(null);
                                            }}
                                            style={{
                                              background: 'none',
                                              border: 'none',
                                              cursor: 'pointer',
                                              fontSize: '16px',
                                              color: '#28a745',
                                              padding: '0 3px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              verticalAlign: 'middle',
                                            }}
                                            title='Thumbs up'
                                          >
                                            <FaThumbsUp style={{ verticalAlign: 'middle', fontSize: '16px' }} />
                                          </button>
                                          <button
                                            onClick={() => {
                                              handleRatingClick(docIndex, catIndex, itemIndex, -1, x);
                                              setOpenRatingFor(null);
                                            }}
                                            style={{
                                              background: 'none',
                                              border: 'none',
                                              cursor: 'pointer',
                                              fontSize: '16px',
                                              color: '#dc3545',
                                              padding: '0 3px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              verticalAlign: 'middle',
                                            }}
                                            title='Thumbs down'
                                          >
                                            <FaThumbsDown style={{ verticalAlign: 'middle', fontSize: '16px' }} />
                                          </button>
                                        </div>
                                      ) : (
                                    <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: '-4px' }}>
                                        <button
                                          onClick={() => setOpenRatingFor(`${docIndex}-${catIndex}-${itemIndex}`)}
                                          style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            fontSize: '16px',
                                            color: hasRating ? (ratingValue === 1 ? '#28a745' : '#dc3545') : '#6c757d',
                                            padding: '0 6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            verticalAlign: 'middle',
                                          }}
                                          title={hasRating && x.rating.reason ? `Feedback: ${x.rating.reason}` : 'Rate this item'}
                                        >
                                          {hasRating ? (
                                            ratingValue === 1 ? <FaThumbsUp style={{ verticalAlign: 'middle', fontSize: '16px' }} /> : <FaThumbsDown style={{ verticalAlign: 'middle', fontSize: '16px' }} />
                                          ) : (
                                            <FaRegThumbsUp style={{ verticalAlign: 'middle', fontSize: '16px' }} />
                                          )}
                                        </button>
                                             </div>
                                      )}
                                    </td>
                                  )}
                                
                                  {/* {surveyInsights &&
                                  surveyInsights.surveyQuestionsInsightsOptimized &&
                                  docIndex != 1 ? (
                                    <td className="">
                                      <Input
                                        type="textarea"
                                        rows={
                                          docIndex == 1
                                            ? 1
                                            : surveyInsights.surveyQuestionsInsightsOptimized
                                            ? 4
                                            : 2
                                        }
                                        className="border-none"
                                        value={x.enhanced}
                                        onChange={(e) =>
                                          handleActionChangeForEnhancedText(
                                            e.target.value,
                                            docIndex,
                                            catIndex,
                                            itemIndex,
                                            selectedActionObjIndex
                                          )
                                        }
                                        style={{
                                          minWidth: isMobile
                                            ? '100px'
                                            : '400px',
                                        }}
                                      />
                                    </td>
                                  ) : null} */}
                                  {/* <td className="" style={{ width: "20%" }}>
                                        <div>
                                          {selectedActionObj &&
                                          selectedActionObj.start_date ? (
                                            <span>
                                              <b>Added:</b>
                                              {moment(
                                                selectedActionObj.start_date
                                              ).format("h:mma MMM D, YYYY")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                          <div>
                                            {selectedActionObj &&
                                            selectedActionObj.share_date ? (
                                              <span>
                                                <b>Shared:</b>
                                                {moment(
                                                  selectedActionObj.share_date
                                                ).format("h:mma MMM D, YYYY")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      </td> */}
                                </tr>
                              )
                            })}
                          </tbody>
                        </Table>
                      </div>
                    )
                  })}
                </div>
              ) : null}
            </div>
          </div>
        ) : null

      return <div className="insight_dynamic_block px-2">{htmlData}</div>
    }
  }

  const renderSurveyInsights = (insightsArray) => {
    return insightsArray.map((section, i) => (
      <div key={i} className="insight-section">
        <h2>{section.heading}</h2>
        {section.data.map((block, j) => (
          <div key={j} className="insight-category">
            <h4>{block.category}</h4>
            <ul>
              {block.items.map((itemObj, k) => (
                <li key={k}>
                  <p> {itemObj.enhanced ?<strong> [Original]</strong>:null} {roundPercentagesInText(itemObj.item)} </p>
                  {itemObj.enhanced ? <p> <strong>[Tailored Approach]</strong> {roundPercentagesInText(itemObj.enhanced)}</p> : null}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    ));
  };

  let enableGenerateInsights = false;
    if (currentTrivvy.allowAnonymousResponses) {
      enableGenerateInsights = currentTrivvy.totalSubmissions >= 5;
    } else {
      enableGenerateInsights = currentTrivvy.totalSubmissions > 0;
  }
 
  const isGenerateInsightsButtonDisabled = dateRange.length < 2 || currentTrivvy.isMessaging ? Object.keys(currentTrivvy).length === 0  || currentTrivvy.totalSubmissions == 0 : Object.keys(summaryData).length === 0  || summaryData.submitted_docs === 0


  if (isFilterLoading ) {
    return (
      <div style={{marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center"}}>
        <SpinnerLoader />
      </div>
    );
  }

  return (
    <div>
      {openDropOffModal && (
        <TrivvyDropoffsModal
          open={openDropOffModal}
          onClose={() => {
            setOpenDropOffModal(false);
          }}
          triviaId={currentTrivvy && currentTrivvy._id}
        />
      )}

      {openSubmissionModal && currentTrivvy && (
        <Modal isOpen={true}>
          <ModalHeader
            className="trivia_modal_header_bg"
            toggle={() => setOpenSubmissionsModal(false)}
          >
            Submissions
          </ModalHeader>
          <ModalBody>
            <TriviaResultsResponses
              questions={currentTrivvy.questions}
              surveyData={currentTrivvy}
              allowAttempts={currentTrivvy.allowAttempts}
              numberOfAttempts={currentTrivvy.numberOfAttempts}
              hideActions
              showTableForSummaryResponses
              userSubmissions={currentTrivvy.userSubmissions}
              isFiltered={currentTrivvy.isFiltered}
              notFetch={true}
              TriviaResultsResponses={currentTrivvy.trivvyHasResponses}
            />
          </ModalBody>
        </Modal>
      )}

      {/* Rating Modal */}
      {ratingModal.open && (
        <Modal isOpen={true} toggle={handleCloseRatingModal}>
          <ModalHeader 
            className="trivia_modal_header_bg"
            toggle={handleCloseRatingModal}
          >
            Please share why you gave this rating?
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <p><strong>Item:</strong> {ratingModal.item && ratingModal.item.item ? ratingModal.item.item : ''}</p>
              <p>
                <strong>Your Rating:</strong>{' '}
                {ratingModal.value === 1 ? (
                  <span style={{ color: '#28a745' }}>
                    <FaThumbsUp /> Thumbs Up
                  </span>
                ) : (
                  <span style={{ color: '#dc3545' }}>
                    <FaThumbsDown /> Thumbs Down
                  </span>
                )}
              </p>
            </div>
            <Input
              type="textarea"
              placeholder="Optional: Share your feedback here..."
              value={ratingFeedback}
              onChange={(e) => setRatingFeedback(e.target.value)}
              rows={4}
            />
          </ModalBody>
          <ModalFooter>
            <Button 
              color="secondary" 
              onClick={handleCloseRatingModal}
              disabled={isSubmittingRating}
            >
              Close
            </Button>
            <Button 
              color="primary" 
              onClick={handleSubmitRating}
              disabled={isSubmittingRating}
            >
              {isSubmittingRating ? 'Submitting...' : 'Submit Feedback'}
            </Button>
          </ModalFooter>
        </Modal>
      )}





      {/* <hr /> */}

      <div>
        <div className="pb-2">
          <div className="res-stats-summary">
            <div className="my-2 d-flex justify-content-center">
              <MultirangeDatePickerDesigned
                dateRange={dateRange}
                handleDateChange={handleDateChange}
              />

              <div
                className="mm-snapshot-menu-container"
                style={{
                  position: "absolute",
                  right: "20px",
                  marginTop: "15px",
                }}
              >

                {/* {currentTrivvy.allowAnonymousResponses && currentTrivvy.totalSubmissions <= 5 && currentTrivvy.totalSubmissions > 0 ? () : ()} */}  
                <Button
                  color="info"
                  onClick={() => handleDownload()}
                  disabled={isDownloadingInsights}
                  style={{
                    opacity: isDownloadingInsights ? 0.6 : 1,
                    pointerEvents: isDownloadingInsights ? "none" : "auto",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  {isDownloadingInsights
                    ? "Generating PDF..."
                    : "Download Insights"}
                </Button>
                {/* <UncontrolledDropdown className="ml-2">
                  <DropdownToggle caret className="button-8">
                    Actions <IoMenu size={'22px'} />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => handleDownload()}>
                      Download Insights
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
              </div>
            </div>

            <div style={{ display: "none" }}>
              <div id="jspdf_export_insight"
                style={{
                  width: "100%",
                  maxWidth: "780px", // landscape A4 printable width
                  margin: "0 auto",
                  padding: "20px",
                  background: "#fff",
                }}
                >
                {insightsBlocks(true)}

                <div className="mt-5 p-3">
                  {currentTrivvy &&
                    currentTrivvy.isMessaging &&
                    recommendation && (
                      <div className="mt-2 recommendation_textbox">
                        {parse(roundPercentagesInText(recommendation))}
                      </div>
                    )}

                  {currentTrivvy &&
                  isSurveyTrivvy &&
                  !currentTrivvy.isMessaging &&
                  surveyInsights &&
                  surveyInsights.surveyQuestionsInsights ? (
                    <div className="mt-2 recommendation_textbox">
                      {/* {parse(surveyInsights.surveyQuestionsInsights)} */}
                      {renderSurveyInsights(
                        surveyInsights.surveyQuestionsInsights
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {insightsBlocks(false)}

            <Row className="trivvy-res-insights-row">
              <Col md={12}>
                <div className="">
                  {currentTrivvy.isMessaging ? (
                    <div className="my-5">
                      {/* <div>
                        Generate Recommended actions for message responses
                      </div> */}
                      {
                        <div className="">
                          {!recommendation ? (
                            <div className="">
                              {insightsLoading ? (
                                <Alert className="generate_insights_loading">
                                  Insights are being generated...
                                </Alert>
                              ) : (
                                <Button
                                  outline
                                  onClick={() => generateRecommendation()}
                                  disabled={
                                    ((summaryData &&
                                    summaryData.submitted_docs <= 0) || isGenerateInsightsButtonDisabled)
                                  }
                                  className="generate_insights_btn"
                                  size="sm"
                                >
                                   Generate Insights{" "}
                                  <span className="ml-2">
                                    {" "}
                                    <BiRecycle />{" "}
                                  </span>{" "}
                                </Button>
                              )}
                            </div>
                          ) : (
                            <div className="recommendation_textbox">
                              {insightsLoading ? (
                                <Alert
                                  className=""
                                  style={{ width: "max-content" }}
                                >
                                  Insights are being generated...
                                </Alert>
                              ) : (
                                <Button
                                  outline
                                  onClick={() => generateRecommendation()}
                                  className="generate_insights_btn"
                                  size="sm"
                                  disabled={isGenerateInsightsButtonDisabled}
                                >
                                  Regenerate Insights{" "}
                                  <span className="ml-2">
                                    {" "}
                                    <BiRecycle />{" "}
                                  </span>{" "}
                                </Button>
                              )}
                              {/* <h4>
                                {' '}
                                <BsStars className="mr-2" /> Recommended actions
                              </h4> */}
                              <div
                                className="mt-4"
                                style={{ textAlign: "justify" }}
                              >
                                {parse(roundPercentagesInText(recommendation))}
                              </div>
                            </div>
                          )}
                        </div>
                      }
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {shareActionsModal && shareActionsModal.open && (
                  <ShareActionsModal
                    open={shareActionsModal}
                    onClose={() => {
                      setShareActionsModal({ open: false, data: [] });
                    }}
                    currentTrivia={currentTrivvy}
                    updateTriviaObject={(data) => {
                      setCurrentTrivia({
                        ...currentTrivvy,
                        ...data,
                      });
                    }}
                    data={shareActionsModal.data}
                    setCurrentTrivia={setCurrentTrivia}
                  />
                )}

                <div>
                  {currentTrivvy &&
                  // isSurveyTrivvy &&
                  !currentTrivvy.isMessaging && currentTrivvy.triviaCategoryType === "SURVEY" ? (
                    <div className="py-3">
                      {/* <div>
                        Generate Insights for survey: {currentTrivvy.name}
                      </div> */}
                      {surveyInsights &&
                      surveyInsights.surveyQuestionsInsights ? (
                        <div>
                          {insightsLoading ? (
                            <Alert
                              className=""
                              style={{ width: "max-content" }}
                            >
                              Insights are being generated...
                            </Alert>
                          ) : (
                            <></>
                          )}

                          <div
                            className={`insights_table_headers ${
                              optimizeInsightsLoading
                                ? "optimize_insights_loading"
                                : ""
                            }`}
                          >
                            <div className="optimize_loader">
                              <img src={Spinner} />
                            </div>
                            {renderInsightsUI(
                              surveyInsights.surveyQuestionsInsights
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="">
                          {insightsLoading ? (
                            <Alert className="">
                              Insights are being generated...
                            </Alert>
                          ) : (
                            <>
                                  {
                                    currentTrivvy && enableGenerateInsights ? 
                                    <>
                                     <div className="d-flex my-4 align-items-center" style={{justifyContent:"flex-start", gap: '1em'}}>
                              <Button
                                  onClick={() => { 
                                      generateSurveyInsights() 
                                    setInsightTabNo(0)
                                  } }
                                  className={`insight_action_category_button ${
                                    insightTabNo == 0 ? 'active' : ''
                                  }`}>
                                  Generate Findings <BsFileBarGraph />
                                </Button>
                            
                                <Button
                                  onClick={() => { 
                                      generateSurveyInsights() 
                                    setInsightTabNo(1)
                                  } }
                                  className={`insight_action_category_button ${
                                    insightTabNo == 1 ? 'active' : ''
                                  }`}>
                                  Generate Next Steps <IoCalendarOutline />
                                  </Button>
                                    <OoPopover
                                    target="regenerate-insights-popover"
                                    placement="right"
                                    headerText="Generate Findings and Next Steps"
                                    bodyText={`Insights are always based on overall submissions (i.e. can not be filtered). Also insights about open text questions can be found in "By Question" Tab.`}
                                  /> 
                            </div>
                            
                                    </> 
                                    : <>

         
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <Button
                                id="generate-insights-popover"
                                outline
                                onClick={generateSurveyInsights}
                                className= {(enableGenerateInsights) ? "generate_insights_btn":"no_generate_insights_btn"}
                                size="sm"
                                disabled={isGenerateInsightsButtonDisabled}

                              > 
                                Too few responses to generate findings and next steps
                                <span className="ml-2">
                                  {" "}
                                  <BiRecycle />{" "}
                                </span>{" "}
                              </Button>
                              <OoPopover
                                target="generate-insights-popover"
                                placement="right"
                                headerText="Generate Findings and Next Steps"
                                bodyText={`Insights are always based on overall submissions (i.e. can not be filtered). Also insights about open text questions can be found in "By Question" Tab.`}
                              />
                            </div>





                                    
                                    </>
                                  }


                              
                            </> 
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCreateTrivvyLoader: (data) =>
      dispatch(actionCreators.setCreateTrivvyLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLoading(TriviaResultsInsights, axios))
